import {connect} from 'react-redux';
import About from '../components/About';

export default connect(
    (state) => ({
        localConfigurator: state.configurator.localConfigurator
    }), null
)(About);